var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaczepa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217.56 116.27",
    width: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 7.93px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 190.76,
    cy: 99.94,
    r: 12.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 156.05,
    cy: 99.94,
    r: 12.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#000",
    points: "13.38 64.26 13.38 3.97 213.59 3.97 213.59 75.63 3.97 75.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 28.6,
    y1: 89.72,
    x2: 28.6,
    y2: 110.06
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaczepa);
export default __webpack_public_path__ + "static/media/naczepa.a55735b007804f189cf6d593a2a81104.svg";
export { ForwardRef as ReactComponent };